module.exports = __webpack_public_path__ + "static/media/sc9.d1deb8f1.jpg";